var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClockFigma = function SvgClockFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 13.334a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667Zm0 1.333a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 4c.368 0 .667.298.667.667v3.057l1.471 1.471a.667.667 0 0 1-.943.943L8.03 8.471A.667.667 0 0 1 7.833 8V4.667c0-.369.299-.667.667-.667Z",
    fill: "#777E91"
  })));
};
export default SvgClockFigma;